import './index.css'
import cn from 'clsx'
import { createElement } from 'react'
import Item from './item'

const selectElement = ordered => (ordered ? 'ol' : 'ul')

export type Props = {
  ordered?: boolean
  children?: React.ReactNode
  className?: string
}

/**
 * A flexible list component that can render as either ordered (ol) or unordered (ul) lists.
 * Provides a standardized way to display list content with optional styling.
 *
 * @param ordered - Whether to render as an ordered list (ol) or unordered list (ul) (default: false)
 * @param children - The list items or content to display
 * @param className - Optional CSS class name for custom styling
 * @returns An ordered or unordered list element with the specified content
 */
const List = (props: Props): React.ReactElement => {
  const { ordered, className, children } = props
  return createElement(
    selectElement(ordered),
    {
      className: cn('List', className),
    },
    children,
  )
}

List.defaultProps = {
  ordered: false,
}
List.Item = Item
export { Item as ListItem }
export default List
